import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const PaymentCancel: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // PayFast callback parameters (handle both uppercase and lowercase)
  const basketId = searchParams.get("BASKET_ID") || searchParams.get("basket_id");
  const transactionId = searchParams.get("TRANSACTION_ID") || searchParams.get("transaction_id");
  
  // Get application ID and course ID from query parameter (added by backend in callback URL)
  const applicationId = searchParams.get("applicationId");
  const courseId = searchParams.get("courseId");

  useEffect(() => {
    // If we have PayFast callback data, send it to backend
    if (basketId && transactionId) {
      handlePayFastCallback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketId, transactionId]);

  const handlePayFastCallback = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/gopayfast/callback/failure`, {
        BASKET_ID: basketId,
        TRANSACTION_ID: transactionId,
        TRANSACTION_STATUS: searchParams.get("TRANSACTION_STATUS") || searchParams.get("transaction_status"),
        RESPONSE_CODE: searchParams.get("RESPONSE_CODE") || searchParams.get("err_code"),
        RESPONSE_MESSAGE: searchParams.get("RESPONSE_MESSAGE") || searchParams.get("err_msg"),
      });
    } catch (err: any) {
      console.error("Callback error:", err);
    }
  };

  const handleRetryPayment = () => {
    if (courseId && applicationId) {
      navigate(`/apply/${courseId}?applicationId=${applicationId}&step=review`);
    } else if (applicationId) {
      navigate("/my-applications");
    } else {
      navigate("/my-applications");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
            <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="mt-4 text-2xl font-bold text-gray-900">Payment Cancelled</h2>
          <p className="mt-2 text-gray-600">
            Your payment was cancelled. No charges have been made to your account.
          </p>
        </div>

        <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <p className="text-sm text-yellow-800">
            <strong>Note:</strong> Your application has been saved as a draft. 
            You can complete the payment process at any time from your applications page.
          </p>
        </div>

        <div className="mt-8 space-y-3">
          <button
            onClick={handleRetryPayment}
            className="w-full px-6 py-3 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
          >
            Retry Payment
          </button>
          <button
            onClick={() => navigate("/my-applications")}
            className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Go to My Applications
          </button>
          <button
            onClick={() => navigate("/courses")}
            className="w-full px-6 py-3 text-cyan-600 hover:text-cyan-700"
          >
            Browse More Courses
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
